import React from 'react'
import EditMovementWorkflow from 'application/movements/EditMovementWorkflow'

function AddMovement() {
    return <EditMovementWorkflow onSuccess="/movements" static={true} />
}

export default AddMovement
